module.exports = __webpack_public_path__ + "img/logon.6fcd1ea1.png";